import React from 'react'

import { DashboardStats } from '../organisms/DashboardStats'
import { DashboardTable } from '../organisms/DashboardTable'
import { MainLayout } from '../organisms/MainLayout'

interface IProps {}

export const DashboardPage: React.FC<IProps> = props => (
  <MainLayout>
    <DashboardStats />
    <DashboardTable />
  </MainLayout>
)
